import { includes } from 'lodash';
import quoteTypes from 'commons-vehicle/Quote/actions/quoteActionTypes.js';
import purchaseMethodsTypes from 'commons-vehicle/PurchaseMethods/actions/purchaseMethodsActionTypes.js';
import QuoteModelV25 from 'commons-vehicle/Quote/models/QuoteModelV25.js';

export default function quoteReducer(state = new QuoteModelV25(), action) {
    switch (action.type) {
        case quoteTypes.SET_QUOTEV25:
            return action.quote;
        default:
            if (includes(purchaseMethodsTypes.QUOTE_UPDATE_TYPES, action.type)) {
                return state.set('modified', true);
            }
            return state;
    }
}
